<mat-card appearance="outlined" [class]="cardClass || ''">
    <mat-card-header [class]="headerClass">
        <mat-card-title [class]="titleClass || ''">
            <div class="flex items-center gap-2">
                <mat-icon [class]="iconClass">{{ iconName }}</mat-icon>
                <span>{{ title }}</span>
            </div>
        </mat-card-title>
    </mat-card-header>

    <mat-card-content [class]="contentClass || 'h-full'">
        <div class="flex h-full flex-col justify-between gap-4">
            {{ content }}

            @if (buttons?.length) {
                <div class="flex flex-col gap-2">
                    @for (btn of buttons; track $index) {
                        @if (btn === 'placeholderButton') {
                            <button class="invisible" mat-raised-button color="primary">Placeholder</button>
                        } @else {
                            <button mat-raised-button color="primary" (click)="clickButton(btn)">
                                {{ btn.text }}
                            </button>
                        }
                    }
                </div>
            }
        </div>
    </mat-card-content>
</mat-card>
